"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiValueEntityValueTypeEnum;
(function (TableauNlpRefinementuiValueEntityValueTypeEnum) {
    TableauNlpRefinementuiValueEntityValueTypeEnum["Unspecified"] = "VALUETYPE_UNSPECIFIED";
    TableauNlpRefinementuiValueEntityValueTypeEnum["Percent"] = "VALUETYPE_PERCENT";
    TableauNlpRefinementuiValueEntityValueTypeEnum["Currency"] = "VALUETYPE_CURRENCY";
    TableauNlpRefinementuiValueEntityValueTypeEnum["Date"] = "VALUETYPE_DATE";
    TableauNlpRefinementuiValueEntityValueTypeEnum["Boolean"] = "VALUETYPE_BOOLEAN";
    TableauNlpRefinementuiValueEntityValueTypeEnum["Number"] = "VALUETYPE_NUMBER";
    TableauNlpRefinementuiValueEntityValueTypeEnum["String"] = "VALUETYPE_STRING";
    TableauNlpRefinementuiValueEntityValueTypeEnum["Keyphrase"] = "VALUETYPE_KEYPHRASE";
})(TableauNlpRefinementuiValueEntityValueTypeEnum = exports.TableauNlpRefinementuiValueEntityValueTypeEnum || (exports.TableauNlpRefinementuiValueEntityValueTypeEnum = {}));
function TableauNlpRefinementuiValueEntityFromJSON(json) {
    return TableauNlpRefinementuiValueEntityFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiValueEntityFromJSON = TableauNlpRefinementuiValueEntityFromJSON;
function TableauNlpRefinementuiValueEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.TableauNlpRefinementuiEntityMetadataFromJSON(json['metadata']),
        'valueType': !runtime_1.exists(json, 'value_type') ? undefined : json['value_type'],
        'fieldLabel': !runtime_1.exists(json, 'field_label') ? undefined : json['field_label'],
        'fieldParentObjectModelLabel': !runtime_1.exists(json, 'field_parent_object_model_label') ? undefined : json['field_parent_object_model_label'],
    };
}
exports.TableauNlpRefinementuiValueEntityFromJSONTyped = TableauNlpRefinementuiValueEntityFromJSONTyped;
function TableauNlpRefinementuiValueEntityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'metadata': _1.TableauNlpRefinementuiEntityMetadataToJSON(value.metadata),
        'value_type': value.valueType,
        'field_label': value.fieldLabel,
        'field_parent_object_model_label': value.fieldParentObjectModelLabel,
    };
}
exports.TableauNlpRefinementuiValueEntityToJSON = TableauNlpRefinementuiValueEntityToJSON;
